export default {
  descricao: "name",
  codigo: "code",
  categoria: "category",
  preco_venda: "sell_value",
  preco_compra: "cost_value",
  marca: "brand",
  unidade: "unit_label",
  ncm: "ncm",
  estoque_minimo: "restock_count",
  total_estoque: "stock_count",
  codigos_de_barras: "barcode",
  cest: "cest",
  cfop: "cfop",
  csosn: "csosn",
  pis: "pis",
  cofins: "cofins",
  origem: "origin"
};



// WEBPACK FOOTER //
// ./src/core/enum/product-batch-defaults.enum.js